import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { fetchSearchResults } from "../API/Search/searchService";
import WaterLoader from "../components/Loader/WaterLoader";

type SearchResultItem = {
  id: string;
  title: string;
  description: string;
  slug: string;
  useSlug: boolean,
};

type SearchResultsResponse = {
  news: SearchResultItem[];
  events: SearchResultItem[];
  projects: SearchResultItem[];
  presses: SearchResultItem[];
  recruitments: SearchResultItem[];
  newsCount: number;
  eventsCount: number;
  projectsCount: number;
  pressesCount: number;
  recruitmentsCount: number;
  totalCount: number;
};

const SearchResults = () => {
  const [searchParams] = useSearchParams();
  const keyword = searchParams.get("keyword") || "";
  const [results, setResults] = useState<SearchResultsResponse | null>(null);

  useEffect(() => {
    const fetchResults = async () => {
      const data = await fetchSearchResults(keyword, "", 1);
      setResults(data);
    };

    fetchResults();
  }, [keyword]);



  const renderSection = (
    title: string,
    items: SearchResultItem[],
    count: number,
    path: string,
    useSlug: boolean,
  ) => {
    if (items.length === 0) return null;
    console.log("results", results)
    return (
      <div className="mb-10 ">
        <h3 className="mb-4 text-xl font-semibold text-primary">
          {title} ({count})
        </h3>
        <ul className="space-y-4">
          {items.map((item) => (
            <li key={item.id} className="p-4 border rounded hover:bg-gray-50">
              <Link to={useSlug ? `/${path}/${item.slug}` : `/${path}`}>
                <p className="font-semibold text-blue-600 hover:underline">
                  {item.title}
                </p>
              </Link>
              <div dangerouslySetInnerHTML={{ __html: item.description }} />
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className="container p-10 px-4 mx-auto mt-20 sm:px-6 lg:px-8">
      <h2 className="mb-20 text-2xl font-bold text-center text-black ">
        Résultats de recherche pour : "{keyword}"
      </h2>

      {results === null ? (
        <p>
          <WaterLoader />
        </p>
      ) : results.totalCount === 0 ? (
        <p>Aucun résultat trouvé.</p>
      ) : (
        <>
          {renderSection("Actualités", results.news, results.newsCount, "actualités", true)}
          {renderSection("Événements", results.events, results.eventsCount, "evenements", true)}
          {renderSection("Projets", results.projects, results.projectsCount, "travaux", true)}
          {renderSection("Communiqués de presse", results.presses, results.pressesCount, "presse", false)}
          {renderSection("Recrutements", results.recruitments, results.recruitmentsCount, "recrutement", false)}

        </>
      )}
    </div>
  );
};

export default SearchResults;
